import ContentPage from './ContentPage'
import ContentPageContainer from './ContentPageContainer'
export { ContentPage }
export { ContentPageContainer }
export default ContentPageContainer
